<template>
    <div>
        <SearchBar @scheduleLineSearch="doScheduleLineSearch" />
        <CCard>
            <CCardBody>
                <div class="row">
                    <div class="col-md-7">
                        <table class="table fixTable">
                            <thead class="thead-light">
                                <tr style="height:102px;">
                                    <th class="text-center h0 text-middle" :title="headers[0]">{{headers[0]}}</th>
                                    <th class="text-center h1 text-middle" :title="headers[1]">{{headers[1]}}</th>
                                    <th class="text-center h2 text-middle" :title="headers[2]">{{headers[2]}}</th>
                                    <th class="text-center h3 text-middle" :title="headers[3]">{{headers[3]}}</th>
                                    <th class="text-center h4 text-middle" :title="headers[4]">{{headers[4]}}</th>
                                    <th class="text-center h5 text-middle" :title="headers[5]">{{headers[5]}}</th>
                                    <th class="text-center h6 text-middle" :title="headers[6]">{{headers[6]}}</th>
                                    <th class="text-center h7 text-middle" :title="headers[7]">{{headers[7]}}</th>
                                    <th class="text-center h8 text-middle" :title="headers[8]">{{headers[8]}}</th>
                                    <th class="text-center h9 text-middle" :title="headers[9]">{{headers[9]}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in schdlnSearchResult" :key="'schLine_' + item.proid + '_' + index">
                                    <td class="text-center">{{item.factoryName}}</td>
                                    <td class="text-center" v-c-tooltip="$toolTip(item.lifnr)">{{item.lifnr}}</td>
                                    <td class="text-center" v-c-tooltip="$toolTip(item.cusAbbreviation)">{{item.cusAbbreviation}}</td>
                                    <td class="text-center" v-c-tooltip="$toolTip(item.matnr)">{{item.matnr}}</td>
                                    <td class="text-center" v-c-tooltip="$toolTip(item.txz01)">{{item.txz01}}</td>
                                    <td class="text-center" v-c-tooltip="$toolTip(item.bsart + '-' + item.ebeln)">{{item.bsart + '-' + item.ebeln}}</td>
                                    <td class="text-center">{{item.ebelp}}</td>
                                    <td class="text-center">{{item.menge | currency}}</td>
                                    <td class="text-center">{{item.grqty | currency}}</td>
                                    <td class="text-center">{{(item.menge - item.grqty) | currency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-5" style="overflow-x:auto;">
                        <table class="table">
                            <thead class="thead-dark">
                                <tr>
                                    <th v-for="(item) in getMonthDays()" :key="'A_' + item.h1" :class="getCss(item)">{{item.h1}}</th>
                                </tr>
                                <tr>
                                    <th v-for="(item) in getMonthDays()" :key="'B_' + item.h1" :class="getCss(item)">{{item.h2}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in schdlnSearchResult" :key="'schLine_' + item.proid + '_' + index">
                                    <td v-for="(it2) in getMonthDays()" :key="'D_' + it2.h1" :class="getCss(it2)">{{getValue(item,it2) | currency}}</td>
                                </tr>                                
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td v-for="(item) in getMonthDays()" :key="'C_' + item.h1" :class="getCss(item)">{{item.h3}}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import SearchBar from './SearchBar'
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
const fixCalcDay = (dStr) =>{
    if(dStr){
        let ymd= dStr.split('/');
        if(ymd.length === 3){
            return  parseInt(ymd[1]) +  '/' + parseInt(ymd[2]);
        }
    }
    return '';
};
export default {
    mixins: [orderMixin],
    components: {
        SearchBar,
    },
    data() {
        return {     
            headers : [
                this.i18n("ScheduleLine.Factory"),this.i18n("ScheduleLine.VendorCode"),this.i18n("ScheduleLine.Vendor"),this.i18n("ScheduleLine.Material"),
                this.i18n("ScheduleLine.ShortText"),this.i18n("ScheduleLine.PurchasingDocument"),this.i18n("ScheduleLine.PurchasingDocumentItem"),
                this.i18n("ScheduleLine.ScheduleQuantity"),this.i18n("ScheduleLine.DeliveredQuantity"),this.i18n("ScheduleLine.UnpaidQuantity")
            ],  
            TwWeekend : [
                this.i18n("Weekend.Sun"),this.i18n("Weekend.Mon"),this.i18n("Weekend.Tue"),this.i18n("Weekend.Wed"),
                this.i18n("Weekend.Thu"),this.i18n("Weekend.Fri"),this.i18n("Weekend.Sat")
            ],
            EnWeekend : [
                'Sun','Mon','Tue','Wed','Thu','Fri','Sat'
            ],
            schdlnRow : {},
            schBarQueryParam : {},
            schdlnSearchResult : [],
            queryMonth : 'C',
            todayIndex : -1,
            limitEndDate : 0
        }
    },
    props : {
    },
    methods: {       
        getValue(item , it){            
            if(item && it) {                
                const vItem = item.schedule[it.h1];
                if(vItem){
                    if(this.todayIndex > 0 && it.h0 < this.todayIndex){                        
                        if(vItem.menge > vItem.grqty){//逾期未交資料，顯示紅色字體
                            it.css1 = 'bg-warning';
                        }
                    }  
                    return vItem.menge;
                }                           
                  
            }
            return ''
        },
        getCss(item){
            let cssStr = 'text-center';
            if(item){
                if(item.css1){
                    cssStr += ' ' + item.css1;
                }
                if(item.css2){
                    cssStr += ' ' + item.css2;
                }        
            }    
            return cssStr;
        },
        getMonthStartDate (dateInMonth){
            return new Date(dateInMonth.getFullYear(),dateInMonth.getMonth(),1);
        },
        getMonthEndDate (dateInMonth){
            const nextMonth = new Date(dateInMonth.getFullYear(),dateInMonth.getMonth() +1,1);
            return nextMonth.addDays(-1);
        },
        getMonthDays (){
            const daysList = [];
            let selectDate = new Date();
            let todayDay = -1 ;            
            if(this.queryMonth === 'N'){//下個月
                selectDate = selectDate.addMonths(1);
            }else { //本月
                todayDay = selectDate.getDate() ;
            }
            this.todayIndex = todayDay;
            let weekendStartIndex = this.getMonthStartDate(selectDate).getDay();
            
            const monthEndDay= this.getMonthEndDate(selectDate);
            const mm = selectDate.getMonth() + 1;
            let endDate = monthEndDay.getDate();
            if(this.limitEndDate > -1){
                endDate = this.limitEndDate;
            }
            //bg-warning(今日)  text-danger(六、日)
            for(let i=1;i<=endDate;i++){
                const item = {h0:0 ,h1:'',h2:'',h3:'',};
                const dayStr = mm + '/' + i;
                item.h0 = i;
                item.h1 = dayStr;
                item.h2= this.TwWeekend[weekendStartIndex];
                if(i === todayDay){
                    item.h3 = this.i18n("Weekend.Today");
                    item.css1 = 'bg-warning';
                }       
                if(weekendStartIndex ===0 || weekendStartIndex ===6)        {
                    item.css2 = 'text-danger';
                }
                weekendStartIndex++;
                if(weekendStartIndex > 6){
                    weekendStartIndex = 0;
                }
                daysList.push(item);
            }
            return daysList;
        },
        doScheduleLineSearch (queryParam){ // Schedule Line查詢
            const url = `${this.$apiUrl_Order}/SearchScheduleLineAsync`
            const param= queryParam;
            const self =this;
            self.limitEndDate = 0;
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                
                    //--成功          
                    const rows = response.data;  
                    const gpForSchLnRow = {};                     
                    const newRows= [];                    
                    let maxEindtTxt = '';
                    //調整並群組取得資料
                    rows.forEach(r => {      
                        r.eindtTxt = self.fixDate(r.eindt);
                        if( r.eindtTxt > maxEindtTxt){
                            maxEindtTxt = r.eindtTxt;
                        }
                        const key = r.ebeln + '\t' + r.ebelp ;
                        let item;
                        if(gpForSchLnRow[key]){
                            item = gpForSchLnRow[key];
                            item.menge += r.menge;
                            item.grqty += r.grqty;
                        }else{
                            gpForSchLnRow[key] = r;
                            item = r;
                            item.schedule = {};
                            newRows.push(item);
                        }                        
                        const key01= fixCalcDay(r.eindtTxt);
                        const objMap = item.schedule;
                        if(objMap[key01]){
                            let vitem= objMap[key01];
                            vitem.grqty +=r.grqty;
                            vitem.menge +=r.menge;
                        }else{
                            objMap[key01] = {eindt : r.eindtTxt ,grqty : r.grqty ,menge :r.menge };
                        }
                    });
                    self.schdlnSearchResult = newRows;     
                    self.schBarQueryParam = param;
                    self.queryMonth = param.queryMonth;
                    self.setCacheQueryParam('ScheduleLine_QueryParam' , param);
                    if(maxEindtTxt){
                        let yyMMdd = maxEindtTxt.split('/');
                        if(yyMMdd.length ==3){
                            const maxDay = parseInt( yyMMdd[2]);
                            if(maxDay && maxDay >0){
                                self.limitEndDate = maxDay;
                            }
                        }
                    }
                }                    
            });
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n("ScheduleLine.Factory"),this.i18n("ScheduleLine.VendorCode"),this.i18n("ScheduleLine.Vendor"),this.i18n("ScheduleLine.Material"),
                this.i18n("ScheduleLine.ShortText"),this.i18n("ScheduleLine.PurchasingDocument"),this.i18n("ScheduleLine.PurchasingDocumentItem"),
                this.i18n("ScheduleLine.ScheduleQuantity"),this.i18n("ScheduleLine.DeliveredQuantity"),this.i18n("ScheduleLine.UnpaidQuantity")
            ]

            this.TwWeekend = [
                this.i18n("Weekend.Sun"),this.i18n("Weekend.Mon"),this.i18n("Weekend.Tue"),this.i18n("Weekend.Wed"),
                this.i18n("Weekend.Thu"),this.i18n("Weekend.Fri"),this.i18n("Weekend.Sat")
            ]
        }
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.col-md-5, .col-md-7 {
    padding: 0;
}
.text-middle{
    vertical-align: middle;
}
.table tr:nth-child(even), .footable tr:nth-child(even) {
    background-color : #fff;
}
.fixTable {
    table-layout:fixed;
}
.fixTable th.h0 {
    overflow: hidden;
    width :50px;
}

.table {
    tbody {
        td {
            min-height: 55px;
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

thead.thead-dark {
    height: 102px;
}

.table .thead-light th {
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>

